module.exports = __webpack_public_path__ + "static/img/item3.eccc770.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big_picture/item3.png
// module id = gmfr
// module chunks = 0